// Action Types
export const FETCH_ACTIVITY_LOGS_REQUEST = "FETCH_ACTIVITY_LOGS_REQUEST";
export const FETCH_ACTIVITY_LOGS_SUCCESS = "FETCH_ACTIVITY_LOGS_SUCCESS";
export const FETCH_ACTIVITY_LOGS_FAILURE = "FETCH_ACTIVITY_LOGS_FAILURE";

export const FETCH_ACTIVITY_SUMMARY_REQUEST = "FETCH_ACTIVITY_SUMMARY_REQUEST";
export const FETCH_ACTIVITY_SUMMARY_SUCCESS = "FETCH_ACTIVITY_SUMMARY_SUCCESS";
export const FETCH_ACTIVITY_SUMMARY_FAILURE = "FETCH_ACTIVITY_SUMMARY_FAILURE";

export const SET_ACTIVITY_LOGS_FILTERS = "SET_ACTIVITY_LOGS_FILTERS";
export const RESET_ACTIVITY_LOGS_FILTERS = "RESET_ACTIVITY_LOGS_FILTERS";

// Action Creators
export const fetchActivityLogsRequest = (filters) => ({
  type: FETCH_ACTIVITY_LOGS_REQUEST,
  payload: filters,
});

export const fetchActivityLogsSuccess = (data) => ({
  type: FETCH_ACTIVITY_LOGS_SUCCESS,
  payload: data,
});

export const fetchActivityLogsFailure = (error) => ({
  type: FETCH_ACTIVITY_LOGS_FAILURE,
  payload: error,
});

export const fetchActivitySummaryRequest = (filters) => ({
  type: FETCH_ACTIVITY_SUMMARY_REQUEST,
  payload: filters,
});

export const fetchActivitySummarySuccess = (data) => ({
  type: FETCH_ACTIVITY_SUMMARY_SUCCESS,
  payload: data,
});

export const fetchActivitySummaryFailure = (error) => ({
  type: FETCH_ACTIVITY_SUMMARY_FAILURE,
  payload: error,
});

export const setActivityLogsFilters = (filters) => ({
  type: SET_ACTIVITY_LOGS_FILTERS,
  payload: filters,
});

export const resetActivityLogsFilters = () => ({
  type: RESET_ACTIVITY_LOGS_FILTERS,
});

// Initial State
const initialState = {
  logs: [],
  summary: null,
  total: 0,
  loading: {
    logs: false,
    summary: false,
  },
  error: {
    logs: null,
    summary: null,
  },
  filters: {
    activity_type: "",
    module: "",
    is_successful: "",
    start_date: null,
    end_date: null,
    user_id: "",
    related_entity_type: "",
    related_entity_id: "",
  },
  pagination: {
    page: 0,
    rowsPerPage: 25,
  },
};

// Reducer
const activityLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, logs: true },
        error: { ...state.error, logs: null },
      };

    case FETCH_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload.logs || [],
        total: action.payload.total || 0,
        loading: { ...state.loading, logs: false },
      };

    case FETCH_ACTIVITY_LOGS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, logs: false },
        error: { ...state.error, logs: action.payload },
      };

    case FETCH_ACTIVITY_SUMMARY_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, summary: true },
        error: { ...state.error, summary: null },
      };

    case FETCH_ACTIVITY_SUMMARY_SUCCESS:
      return {
        ...state,
        summary: action.payload,
        loading: { ...state.loading, summary: false },
      };

    case FETCH_ACTIVITY_SUMMARY_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, summary: false },
        error: { ...state.error, summary: action.payload },
      };

    case SET_ACTIVITY_LOGS_FILTERS:
      // Handle dayjs objects by converting them to ISO strings for storage
      const processedFilters = { ...action.payload };
      if (
        processedFilters.start_date &&
        typeof processedFilters.start_date === "object" &&
        processedFilters.start_date.isValid
      ) {
        processedFilters.start_date = processedFilters.start_date.toISOString();
      }
      if (
        processedFilters.end_date &&
        typeof processedFilters.end_date === "object" &&
        processedFilters.end_date.isValid
      ) {
        processedFilters.end_date = processedFilters.end_date.toISOString();
      }

      return {
        ...state,
        filters: { ...state.filters, ...processedFilters },
        pagination: { ...state.pagination, page: 0 }, // Reset to first page when filters change
      };

    case RESET_ACTIVITY_LOGS_FILTERS:
      return {
        ...state,
        filters: initialState.filters,
        pagination: { ...state.pagination, page: 0 },
      };

    default:
      return state;
  }
};

export default activityLogReducer;
